export default "__VITE_ASSET__b7f56032__"